import { Component } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { ListaFuncionalidadeComponent } from '../../../shared/components/lista-funcionalidade/lista-funcionalidade.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';

@Component({
  selector: 'app-notas-fiscais-home',
  imports: [HeaderComponent, ListaFuncionalidadeComponent],
  templateUrl: './notas-fiscais-home.component.html',
  styleUrl: './notas-fiscais-home.component.css',
})
export class NotasFiscaisHomeComponent {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor() {
    this.moduloEnum = ModuloEnum.NotasFiscais;
    this.funcionalidadeEnum = FuncionalidadeEnum.NotasFiscais_PainelContador;
  }
}
